module.exports = __webpack_public_path__ + "img/check-circle.611ff22f.svg";